import { gql } from '@apollo/client';

import { AssignmentResults } from '../../types';
import { assignmentResultFragment } from '../fragments';

export interface GetAssignmentResultsQueryVariables {
  courseId: string;
  assignmentId: string;
}

export interface GetAssignmentResultsQueryResult {
  results: AssignmentResults;
}

export const getAssignmentResultsQuery = gql`
  query GetAssignmentResultsQuery($courseId: String!, $assignmentId: String!) {
    results(courseId: $courseId, assignmentId: $assignmentId)
      @rest(type: "AssignmentResult", path: "courses/{args.courseId}/assignments/{args.assignmentId}/results") {
      ...AssignmentResult
    }
  }
  ${assignmentResultFragment}
`;
